import React from 'react';
import { ExternalLink } from 'lucide-react';
import { Facebook, Twitter, HeartHandshake, FileText, Instagram, Linkedin, Send } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white pt-20 pb-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-12 mb-16">
          <div>
            <a href="/" className="mb-3 flex items-left">
                <img 
                  src="https://i.imgur.com/aIvzv9g.png"
                  alt="France Student"
                />
            </a>
            <p className="text-gray-400 mb-6">
              Ensemble, nous tissons les fils de l'inclusion numérique pour tous les étudiants.
            </p>
            <div className="flex space-x-4">
              <a href="http://instagram.com/francestudent" className="text-gray-400 hover:text-white transition-colors">
                <Instagram className="w-6 h-6" />
              </a>
              <a href="https://www.linkedin.com/company/francestudent" className="text-gray-400 hover:text-white transition-colors">
                <Linkedin className="w-6 h-6" />
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-6">Liens Rapides</h4>
            <ul className="space-y-4">
              <li><a href="https://francestudent.org/" className="text-gray-400 hover:text-white transition-colors">Accueil</a></li>
              <li><a href="https://francestudent.org/about" className="text-gray-400 hover:text-white transition-colors">À propos</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-6">Services</h4>
            <ul className="space-y-4">
              <li><a href="/services/canva-pro" className="text-gray-400 hover:text-white transition-colors">Canva Pro</a></li>
              <li><a href="/services/codex-claude-code" className="text-gray-400 hover:text-white transition-colors">Codex / Claude Code</a></li>
              <li><a href="/services/hebergement" className="text-gray-400 hover:text-white transition-colors">Hébergement Web</a></li>
              <li><a href="/services/ressources" className="text-gray-400 hover:text-white transition-colors">Ressources</a></li>
              <li><a href="https://my.francestudent.org/submitticket.php" className="text-gray-400 hover:text-white transition-colors">Support</a></li>
            </ul>
          </div>

          <div>
            <a href="https://my.francestudent.org/" className="text-lg font-semibold block mb-6"><u>my.francestudent.org <ExternalLink className="inline-block w-5 h-5"/></u></a>
            <a href="https://discord.gg/francestudent" className="text-lg font-semibold block mb-6"><u>discord.gg/francestudent <ExternalLink className="inline-block w-5 h-5"/></u></a>
            <a href="https://www.journal-officiel.gouv.fr/pages/associations-detail-annonce/?q.id=id:202300401709/" className="text-lg font-semibold block mb-6"><u>journal-officiel.gouv.fr <ExternalLink className="inline-block w-5 h-5"/></u></a>
          </div>
        </div>

        <div className="text-center text-lg border-t border-gray-800 pt-8">
        <a 
              href="https://my.francestudent.org/submitticket.php" 
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center text-gray-400 hover:text-white transition-colors"
            >
              <HeartHandshake className="w-5 h-5 mr-2" />
              Centre d'assistance
        </a>
        &nbsp;&nbsp;&nbsp;
        <a 
              href="/statuts.pdf" 
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center text-gray-400 hover:text-white transition-colors"
            >
              <FileText className="w-5 h-5 mr-2" />
              Nos statuts
        </a>
        &nbsp;&nbsp;&nbsp;
        <a 
              href="/mentions-legales.pdf" 
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center text-gray-400 hover:text-white transition-colors"
            >
              <FileText className="w-5 h-5 mr-2" />
              Mentions Légales
        </a>
        &nbsp;&nbsp;&nbsp;
        <a 
              href="/cgu.pdf" 
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center text-gray-400 hover:text-white transition-colors"
            >
              <FileText className="w-5 h-5 mr-2" />
              Conditions générales d'utilisation
        </a>
        &nbsp;&nbsp;&nbsp;
        <a 
              href="/politique-de-confidentialite.pdf" 
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center text-gray-400 hover:text-white transition-colors"
            >
              <FileText className="w-5 h-5 mr-2" />
              Politique de confidentialité
        </a>
          <p className="text-center text-sm text-gray-400 pt-4">
            © {new Date().getFullYear()} FRANCE STUDENT. Tous droits réservés.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
